

import { defineComponent} from 'vue'
import {Container} from '@/components/bosons'
import {Header, Presentation, Services} from '@/components/organisms'

export default defineComponent({
  components: {Container, Header, Presentation, Services}
})
